import * as React from 'react';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Opgavepakke } from '../../models/Opgavepakke';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import OpgavepakkePresenter from './OpgavepakkePresenter';
import { getSkoleaarFromDate } from '../../models/SkoleAar';
import { Redirect } from 'react-router-dom';
import NotificationModule from '../../uiComponents/layout/Notification';
import { OpgaveListItem } from '../../models/OpgaveListItem';
import { Logbog } from '../../models/Logbog';
import { EditorStateModel } from '../../models/EditorStateModel';
import { Vejledning } from '../../models/Vejledning';
import { VejledningAfsnit } from '../../models/VejledningAfsnit';
import DraftHelper from '../../infrastructure/DraftHelper';
import { EditorState } from 'draft-js';

export interface OpgavepakkeCreateContainerProps {
}

export interface OpgavepakkeCreateContainerState {
    opgavepakke: Opgavepakke;
    editorStates: EditorStateModel[];
    opgaver?: OpgaveListItem[];
    logboeger?: Logbog[];
    validationResult?: ValidationResult;
    isSaved: boolean;
    isSubmitting: boolean;
}

class OpgavepakkeCreateContainer extends React.Component<OpgavepakkeCreateContainerProps, OpgavepakkeCreateContainerState> {
    constructor(props: OpgavepakkeCreateContainerProps) {
        super(props);

        const opgavepakke = new Opgavepakke();
        opgavepakke.vejledning = new Vejledning();
        opgavepakke.vejledning.afsnit = new Array();        
        opgavepakke.skoleaar = getSkoleaarFromDate(new Date());
        opgavepakke.opgavepakkeOpgaver = new Array();
        this.state = { opgavepakke: opgavepakke, isSaved: false, isSubmitting: false, editorStates: new Array() };

        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onAddAfsnit = this.onAddAfsnit.bind(this);
        this.onAfsnitRemoved = this.onAfsnitRemoved.bind(this);
        this.onEditorChanged = this.onEditorChanged.bind(this);
        this.onVejledningChanged = this.onVejledningChanged.bind(this);
    }

    componentDidMount() {    
        let self = this;   
        let apiCaller = createApiCaller();

        apiCaller.getLogboeger().then(response => 
            self.setState({logboeger: response})
        );

        apiCaller.getOpaveListItems().then(response =>
            self.setState({opgaver: response})
        );  
        
        self.onAddAfsnit();        
    }

    onChange(fieldName: string, value: any) {
        const opgavepakke = this.state.opgavepakke;
        opgavepakke[fieldName] = value;

        this.setState({ opgavepakke: opgavepakke });
    }

    onSave() {
        this.setState({isSubmitting: true});
        const self = this;
        createApiCaller().createOpgavepakke(this.state.opgavepakke).then(response =>
            self.setState({ validationResult: response, isSaved: response.isValid, isSubmitting: false })
        );
    }

    onAfsnitRemoved(index: number) {
        const tmpState = this.state;

        if (tmpState.opgavepakke.vejledning !== undefined) {
            tmpState.opgavepakke.vejledning.afsnit.splice(index, 1);
            this.setState(tmpState);
        }
    }

    onAddAfsnit() {
        let tmpState = this.state;

        if (tmpState.opgavepakke.vejledning !== undefined) {
            const afsnit = new VejledningAfsnit();
            afsnit.overskrift = '';
            afsnit.editorStateJson = '';

            tmpState.opgavepakke.vejledning.afsnit.push(afsnit);

            const editorStateModel = new EditorStateModel();
            editorStateModel.editorState = DraftHelper.getEmptyEditorState();
            editorStateModel.index = tmpState.editorStates.length;
            
            tmpState.editorStates.push(editorStateModel);

            this.setState(tmpState);            
        }
    }

    onVejledningChanged = (index: number, fieldName: string, value: any) => {
        let tmpState = this.state;

        if (tmpState.opgavepakke.vejledning !== undefined) {
            let afsnit = tmpState.opgavepakke.vejledning.afsnit[index];
            if (afsnit !== undefined) {
                afsnit[fieldName] = value;
                this.setState(tmpState);
            }
        }
    }

    onEditorChanged = (index: number, editorState: EditorState): void => {
        if (this.state.opgavepakke.vejledning !== undefined) {
            let vejledning = this.state.opgavepakke.vejledning;
            let editorStates = this.state.editorStates;
            let editorStateModel = editorStates[index];

            if (editorStateModel !== undefined) {
                editorStateModel.editorState = editorState;
            }

            let afsnit = vejledning.afsnit[index];

            if (afsnit !== undefined) {
                afsnit.editorStateJson = DraftHelper.getEditorStateAsJson(editorState);
            }

            let opgavepakke = this.state.opgavepakke;
            opgavepakke.vejledning = vejledning;

            this.setState({ editorStates: editorStates, opgavepakke: opgavepakke });
        }
    }

    render() {
        if (this.state.isSaved) {
            NotificationModule.showSuccess('', 'Opgavepakke er oprettet', false);
            return <Redirect to='/opgavepakker' />;
        } else {
            return (
                <OpgavepakkePresenter
                    opgavepakke={this.state.opgavepakke}
                    errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                    onChange={this.onChange}
                    onSave={this.onSave}
                    opretRediger='Opret'
                    isSubmitting={this.state.isSubmitting}
                    opgaver={this.state.opgaver === undefined ? [] : this.state.opgaver.filter(o => o.aktiv)}
                    logboeger={this.state.logboeger === undefined ? [] : this.state.logboeger}
                    isSaved={this.state.isSaved}
                    validationResult={this.state.validationResult === undefined ? new ValidationResult() : this.state.validationResult}
                    editorStates={this.state.editorStates}
                    onAfsnitRemoved={this.onAfsnitRemoved}
                    onAddAfsnit={this.onAddAfsnit}
                    onEditorChanged={this.onEditorChanged}
                    onVejledningChanged={this.onVejledningChanged}
                />
            );
        }
    }
}

export default OpgavepakkeCreateContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgavepakke/OpgavepakkeCreateContainer.tsx